export class FormInputErrorTools {

    public static hasError(form, name, submitted, eform=false): boolean {
        if(eform){
            if(form){
                if (form.errors !== null) {
                    const b1 = form.invalid && (form.touched || form.dirty) && form.value !== 'null';
                    const b2 = form.errors?.required && submitted;
                    return b1 || b2;
                }
                // pour les règles de gestion
                if (form.value?.ctrlValidation) {
                    return true;
                }
            }
            return false;
        } else if (form.controls[name]) {
            if (form.controls[name].errors !== null) {
                const b1 = form.controls[name].invalid;
                const b2 = form.controls[name].errors.required && submitted;
                return b1 || b2;
            }
            // pour les règles de gestion
            if (form.controls[name].value?.ctrlValidation) {
                return true;
            }
            return false;
        } else {
            // Le contrôle n'existe pas encore dans le formulaire, retourner false silencieusement
            // Cela arrive quand un composant avec *ngIf est détruit puis recréé
            // (ex: radio bouton "Autres renseignements demandés" décoché/recoché)
            return false;
        }
    }

    public static hasErrorPatternOrMaxLength(form): boolean {
        if(form){
            if (form.errors !== null) {
                return form.invalid && (form.touched || form.dirty) && form.value !== 'null' && (form.errors?.pattern || form.errors?.maxlength);
            }
        }
        return false;
    }
}

